import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";

interface Props {
    translatedRoutes: { nl?: { relative_url: string; lang: string }; fr?: { relative_url: string; lang: string }; en?: { relative_url: string; lang: string } };
    inverse?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'language-switch',
  props: {
    translatedRoutes: { type: Object, required: true },
    inverse: { type: Boolean, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();



const showLanguageDropdown = ref(false);

const lang = computed(() => {
    return document.documentElement.lang;
});

const __returned__ = { showLanguageDropdown, lang }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})